import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksCalculationVolumeMetrics(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		dtConfig[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].getDoneWorksCalculationVolumeMetrics,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksCalculationVolumeMetricPreview(companyId, doneWorkId, calculationVolumeMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		dtConfig[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].getDoneWorksCalculationVolumeMetricPreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				calculationVolumeMetricId,
			},
		},
	)
}
function getDoneWorksCalculationVolumeMetricPopup(companyId, doneWorkId, calculationVolumeMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,
		dtConfig[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].getDoneWorksCalculationVolumeMetricPopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				calculationVolumeMetricId,
			},
		},
	)
}

function createDoneWorksCalculationVolumeMetric(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].createDoneWorksCalculationVolumeMetric, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksCalculationVolumeMetric(companyId, doneWorkId, calculationVolumeMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].getDoneWorksCalculationVolumeMetric, {
		urlParams: {
			companyId,
			doneWorkId,
			calculationVolumeMetricId,
		},
	})
}

function patchDoneWorksCalculationVolumeMetric(companyId, doneWorkId, calculationVolumeMetricId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].patchDoneWorksCalculationVolumeMetric, {
		urlParams: {
			companyId,
			doneWorkId,
			calculationVolumeMetricId,
		},
		...data,
	})
}

function patchDoneWorksCalculationVolumeMetricIntervals(companyId, doneWorkId, calculationVolumeMetricId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].patchDoneWorksCalculationVolumeMetricIntervals, {
		urlParams: {
			companyId,
			doneWorkId,
			calculationVolumeMetricId,
		},
		...data,
	})
}

function patchDoneWorksCalculationVolumeMetricBulkUpdate(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].patchDoneWorksCalculationVolumeMetricBulkUpdate, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function putDoneWorksCalculationVolumeMetric(companyId, doneWorkId, calculationVolumeMetricId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].putDoneWorksCalculationVolumeMetric, {
		urlParams: {
			companyId,
			doneWorkId,
			calculationVolumeMetricId,
		},
		...data,
	})
}

function deleteDoneWorksCalculationVolumeMetric(companyId, doneWorkId, calculationVolumeMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS,dtConfig[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].deleteDoneWorksCalculationVolumeMetric, {
		urlParams: {
			companyId,
			doneWorkId,
			calculationVolumeMetricId,
		},
	})
}

export default {
	getDoneWorksCalculationVolumeMetrics,
	getDoneWorksCalculationVolumeMetricPopup,
	getDoneWorksCalculationVolumeMetricPreview,
	getDoneWorksCalculationVolumeMetric,
	patchDoneWorksCalculationVolumeMetric,
	patchDoneWorksCalculationVolumeMetricIntervals,
	patchDoneWorksCalculationVolumeMetricBulkUpdate,
	putDoneWorksCalculationVolumeMetric,
	createDoneWorksCalculationVolumeMetric,
	deleteDoneWorksCalculationVolumeMetric,
}
